import React, { useState } from "react";
import BlockIcon from "@material-ui/icons/Block";
import Skeleton from "@material-ui/lab/Skeleton";
import { useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  FormControl,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  DialogContent,
  DialogContentText,
  Box,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { red, grey } from "@material-ui/core/colors";
import { STATUS } from "../../main/status";

import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";

import ExpandIcon from "@material-ui/icons/Add";
import MinimizeIcon from "@material-ui/icons/Remove";
import { StorageUser } from "../../main/StorageUser";

import Authorization from "./Authorization";

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: red[900],
    color: "#fff",
    "&:hover": {
      backgroundColor: red[800],
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  textLabel: {
    marginBottom: 0,
  },
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    borderTop: `1px solid ${grey[200]}`,
    maxHeight: "62vh",
    minWidth: 380,
    minHeight: 130,
  },
  action: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  skeleton: {
    margin: "5px",
    backgroundColor: "#ccc",
  },
  accordionItem: {
    border: 0,
    boxShadow: "none",
    padding: 0,
    margin: 0,
  },
  accordionSummary: {
    padding: 0,
  },
  accordionIcon: {
    color: "#F80032",
    marginRight: "10px",
  },
  accordionSubItem: {
    padding: "0 35px",
  },
  accordionSubItemDivider: {
    width: "calc(100% + 70px)",
    marginLeft: "-35px",
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
}));

export default function MotivoCancelamentoModal(props) {
  const { reasons } = useSelector((state) => state.orders);
  const {
    orderNumber,
    action,
    status,
    openModal,
    handleClose,
    origem,
    codigoExterno,
    ignoreReason,
    retry,
  } = props;
  const [reason, setReason] = useState("");
  const [expanded, setExpanded] = useState("");

  const classes = useStyles();

  const naoEntregue = status === STATUS.SAIU_PARA_ENTREGA;
  const recusado = status === STATUS.EM_SEPARACAO;

  const handleCancelar = ({ nomeAutorizador, emailAutorizador } = {}) => {
    const newStatus = naoEntregue ? STATUS.EM_SEPARACAO : STATUS.CANCELADO;
    action(
      orderNumber,
      newStatus,
      null,
      reason,
      origem,
      null,
      null,
      true,
      codigoExterno,
      recusado,
      retry,
      nomeAutorizador,
      emailAutorizador
    );
    handleClose();
  };

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const disabled = !ignoreReason && reason.length === 0;

  const handleChange = (event) => {
    setReason(event.target.value);
  };

  const handleChangeAccordion = (value) => {
    setExpanded(value === expanded ? "" : value);
  };

  const getCancelarLabel = () => {
    switch (status) {
      case STATUS.NOVO_PEDIDO:
      case STATUS.EM_SEPARACAO:
        return "recusar";
      case STATUS.SAIU_PARA_ENTREGA:
        return "não entregue";
      default:
        return "cancelar";
    }
  };

  const label = getCancelarLabel();

  return (
    <>
      <Dialog open={openModal}>
        <DialogContent>
          {naoEntregue ? (
            <DialogContentText color="textPrimary">
              O pedido #
              {origem === "PEGUE_NA_LOJA"
                ? codigoExterno.split("#")[0]
                : codigoExterno}{" "}
              não foi entregue com sucesso?
            </DialogContentText>
          ) : (
            <>
              <DialogContentText color="textPrimary" align="center">
                Tem certeza que deseja <b>{label}</b> o pedido #
                {origem === "PEGUE_NA_LOJA"
                  ? codigoExterno.split("#")[0]
                  : codigoExterno}
                ?
              </DialogContentText>
              {origem === "PEGUE_NA_LOJA" && (
                <DialogContentText color="primary" align="center">
                  Após o cancelamento deste pedido, ele deve ser <br />
                  preparado para coleta da transportadora
                </DialogContentText>
              )}
            </>
          )}

          {ignoreReason ? (
            <></>
          ) : (
            <DialogContentText
              color="initial"
              variant="body2"
              className={classes.textLabel}
            >
              Selecione o motivo abaixo:
            </DialogContentText>
          )}
        </DialogContent>

        {ignoreReason ? (
          <></>
        ) : (
          <DialogContent className={classes.listContent}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="Motivo"
                name="reason"
                value={reason}
                onChange={handleChange}
              >
                {reasons && reasons.length
                  ? reasons.map((item, index) => (
                      <React.Fragment key={item.code}>
                        {item.subItems.length > 0 ? (
                          <Accordion
                            expanded={item.code === expanded}
                            onChange={() => handleChangeAccordion(item.code)}
                            className={classes.accordionItem}
                          >
                            <AccordionSummary
                              className={classes.accordionSummary}
                              aria-controls={`subitems-${item.code}`}
                              id={item.code}
                            >
                              {item.code === expanded ? (
                                <MinimizeIcon
                                  className={classes.accordionIcon}
                                />
                              ) : (
                                <ExpandIcon className={classes.accordionIcon} />
                              )}
                              <Typography>{item.description}</Typography>
                            </AccordionSummary>

                            <Divider />

                            <AccordionDetails
                              className={classes.accordionSubItem}
                            >
                              <Box
                                flexGrow={1}
                                display="grid"
                                className="testeBox"
                              >
                                {item.subItems.map((subItem, index) => (
                                  <React.Fragment key={subItem.code}>
                                    <FormControlLabel
                                      value={subItem.code}
                                      selected={subItem.code === reason}
                                      control={<Radio />}
                                      label={subItem.description}
                                      className="testeFormControlLabel"
                                    />

                                    {index + 1 !== item.subItems.length && (
                                      <Divider
                                        className={
                                          classes.accordionSubItemDivider
                                        }
                                      />
                                    )}
                                  </React.Fragment>
                                ))}
                              </Box>
                            </AccordionDetails>
                          </Accordion>
                        ) : (
                          <FormControlLabel
                            value={item.code}
                            selected={item.code === reason}
                            control={<Radio />}
                            label={item.description}
                          />
                        )}

                        {index + 1 !== reasons.length && <Divider />}
                      </React.Fragment>
                    ))
                  : [1, 2, 3, 4].map((i) => (
                      <div key={i}>
                        <Skeleton
                          variant="text"
                          animation="wave"
                          className={classes.skeleton}
                        />
                      </div>
                    ))}
              </RadioGroup>
            </FormControl>
          </DialogContent>
        )}

        {requireAutorizador && (
          <Authorization
            action={handleCancelar}
            disabled={disabled}
            cancel={handleClose}
            cancelText="Fechar"
            actionText={
              origem === "PEGUE_NA_LOJA"
                ? "Solicitar Coleta"
                : `${label} Pedido`
            }
            endIcon={origem === "PEGUE_NA_LOJA" ? null : <BlockIcon />}
          />
        )}

        {!requireAutorizador && (
          <DialogActions className={classes.action}>
            <Box flexGrow={1} display="flex" p={0}>
              <Box flexGrow={1}>
                <Button autoFocus onClick={handleClose} color="default">
                  Fechar
                </Button>
              </Box>
              <Box>
                {origem !== "PEGUE_NA_LOJA" && (
                  <Button
                    onClick={handleCancelar}
                    variant="contained"
                    color="primary"
                    startIcon={<BlockIcon />}
                    autoFocus
                    disabled={disabled}
                  >
                    {naoEntregue ? "Pronto para sair" : `${label} Pedido`}
                  </Button>
                )}
                {origem === "PEGUE_NA_LOJA" && (
                  <Button
                    onClick={handleCancelar}
                    variant="contained"
                    color="primary"
                    autoFocus
                    disabled={disabled}
                  >
                    Solicitar coleta
                  </Button>
                )}
              </Box>
            </Box>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
}
